// Translations File for the shared e-Transfer security question field

export const securityQuestionEn = {
  'security-question-select-placeholder': 'Please select…',
  'security-question-preset-birth-city': 'What city was I born in?',
  'security-question-preset-first-pet': 'What was my first pet\'s name?',
  'security-question-preset-childhood-street': 'What street did I grow up on?',
  'security-question-preset-sports-team': 'What is my favourite sports team?',
  'security-question-preset-first-car': 'What was my first car?',
  'security-question-custom-option': 'Write my own…',
  'security-question-custom-label': 'Your question',
  'security-question-guidance':
    'Pick something only the two of you would know — and never send the answer in the same message as the transfer.',
  'security-question-hint':
    '{min}–{max} characters. Letters, accented letters, numbers, spaces and common punctuation such as \' - , . ? ! are allowed, but not two spaces in a row.',
  'security-question-error-required': 'Choose a security question or write your own.',
  'security-question-error-character':
    'Security questions can\'t include the character {character}. Use letters, accented letters, numbers, spaces and common punctuation such as \' - , . ? !',
  'security-question-error-spaces': 'Security questions can\'t contain two spaces in a row.',
  'security-question-error-length': 'Security questions must be {min}–{max} characters long.',
  'security-question-error-contains-answer':
    'Your question contains its own answer. Anyone who reads the question would know it, so choose one that doesn\'t give the answer away.',
};

export const securityQuestionFr = {
  'security-question-select-placeholder': 'Veuillez sélectionner…',
  'security-question-preset-birth-city': 'Quelle est ma ville natale?',
  'security-question-preset-first-pet': 'Comment s\'appelait mon premier animal?',
  'security-question-preset-childhood-street': 'Sur quelle rue ai-je grandi?',
  'security-question-preset-sports-team': 'Quelle est mon équipe sportive préférée?',
  'security-question-preset-first-car': 'Quelle était ma première voiture?',
  'security-question-custom-option': 'Écrire ma propre question…',
  'security-question-custom-label': 'Votre question',
  'security-question-guidance':
    'Choisissez une question dont vous seuls connaissez la réponse — et n\'envoyez jamais la réponse dans le même message que le virement.',
  'security-question-hint':
    'De {min} à {max} caractères. Les lettres, les lettres accentuées, les chiffres, les espaces et la ponctuation courante comme \' - , . ? ! sont acceptés, mais pas deux espaces de suite.',
  'security-question-error-required': 'Choisissez une question de sécurité ou rédigez la vôtre.',
  'security-question-error-character':
    'Les questions de sécurité ne peuvent pas contenir le caractère {character}. Utilisez des lettres, des lettres accentuées, des chiffres, des espaces et la ponctuation courante comme \' - , . ? !',
  'security-question-error-spaces': 'Les questions de sécurité ne peuvent pas contenir deux espaces de suite.',
  'security-question-error-length': 'Les questions de sécurité doivent contenir de {min} à {max} caractères.',
  'security-question-error-contains-answer':
    'Votre question contient sa propre réponse. Toute personne qui lit la question la connaîtrait; choisissez-en une qui ne révèle pas la réponse.',
};
